import React from "react";
import { Paper, RaisedButton, TextField } from "material-ui";
import assign from "lodash/assign";
import { Link } from "react-router";

import connectToStores from "alt-utils/lib/connectToStores";
import UserActions from "../actions/UserActions";
import UserStore from "../stores/UserStore";

import InfoNotice from "./partials/info-notice.jsx";
import LinkLike from "./partials/link-like.jsx";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      hasGoneBack: false,
      hasClearedErrors: false
    };

    this._login = this._login.bind(this);
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return UserStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  _login() {
    UserActions.login(
      this.state.username,
      this.state.password,
      /* noRedirect */ true
    );
  }

  componentWillMount() {
    if (this.props.location.state && this.props.location.state.username) {
      this.setState({ username: this.props.location.state.username });
    }

    if (
      this.props.location.state &&
      this.props.location.state.clearErrors &&
      !this.state.hasClearedErrors
    ) {
      this.setState({ hasClearedErrors: true });
      UserActions.clearErrors.defer();
    }

    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(props) {
    // If logged in
    if (props.isLoggedIn || props.loginSuccess) {
      setTimeout(() => {
        if (
          this.props.location.query.next === "back" &&
          !this.state.hasGoneBack
        ) {
          this.context.router.goBack();
          this.setState({ hasGoneBack: true });
        } else if (this.props.location.query.feedback) {
          const destination = props.location.query.redirect;
          window.location.assign(
            `${destination}${
              destination.indexOf("?") === -1 ? "?" : "&"
            }ssoToken=${props.data.canny_hash}`
          );
        } else {
          this.context.router.push(
            this.props.location.query.next || "/welcome"
          );
        }
      }, 0);
    }
  }

  getStyles() {
    return {
      page: {
        minHeight: "60vh"
      },
      container: {
        margin: "0 auto",
        marginTop: "10%",
        width: "90%",
        maxWidth: 500,
        padding: 20,
        textAlign: "center",
        borderRadius: 10
      },
      h2: {
        lineHeight: 2,
        fontWeight: "normal",
        marginBottom: 0
      },
      form: {
        maxWidth: 256,
        margin: "0 auto"
      },
      actions: {
        marginTop: 10
      },
      error: {
        color: "#FF4136",
        margin: "0.5em 0 0.5em"
      },
      img: {
        display: "block",
        height: 30,
        margin: "0 auto"
      },
      forgot: {
        marginTop: 20
      }
    };
  }

  render() {
    var styles = this.getStyles();

    return (
      <div style={styles.page}>
        <Paper style={styles.container}>
          <InfoNotice
            verticalCenterIcon
            style={{ textAlign: "left", marginBottom: "1.5em" }}
          >
            This site is for organizers and creators to manage their events and
            films. If you're an attendee, login on the event website instead.{" "}
            <LinkLike onTouchTap={() => Intercom("showNewMessage")}>
              Need help?
            </LinkLike>
          </InfoNotice>
          <h2 style={styles.h2}>
            <img
              src="/img/eventive-dark.png"
              alt="Eventive"
              style={styles.img}
            />
            Organizer & Creator Login
          </h2>
          {this.props.loginErrorMessage ? (
            <div style={styles.error}>{this.props.loginErrorMessage}</div>
          ) : null}
          <form style={styles.form}>
            <div>
              <TextField
                hintText="Email address"
                value={this.state.username}
                fullWidth={true}
                onChange={e =>
                  this.setState(
                    assign({}, this.state, { username: e.target.value })
                  )
                }
                inputStyle={{ height: 36, marginTop: 6, paddingBottom: 6 }} // better location of autofill highlight
                disabled={this.props.loginInProgress}
              />
            </div>
            <div>
              <TextField
                hintText="Password"
                fullWidth={true}
                disabled={this.props.loginInProgress}
                value={this.state.password}
                onChange={e =>
                  this.setState(
                    assign({}, this.state, { password: e.target.value })
                  )
                }
                onKeyDown={e => {
                  if (e.keyCode === 13) this._login();
                }}
                inputStyle={{ height: 36, marginTop: 6, paddingBottom: 6 }} // better location of autofill highlight
                type="password"
              />
            </div>
            <div style={styles.actions}>
              <RaisedButton
                label={this.props.loginInProgress ? "Logging in..." : "Login"}
                disabled={this.props.loginInProgress}
                primary={true}
                onTouchTap={this._login}
              />
            </div>
          </form>
          <div style={styles.forgot}>
            <Link
              to={{
                pathname: "/sso",
                state: { login_hint: this.state.username }
              }}
            >
              Login with SSO
            </Link>{" "}
            &middot; <Link to="/forgot">Forgot password?</Link>
          </div>
        </Paper>
      </div>
    );
  }
}

export default connectToStores(Login);



// WEBPACK FOOTER //
// ./src/app/components/login.jsx